import * as navigation from 'Navigation';

export default class RequestResponseTabState extends navigation.TabState {
  defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Fulfillment',
      closeable: false,
      preferenceKey: 'request-results',
    };
  }
}
